export default __webpack_public_path__ + "static/media/work-min.2ed11c9d.png";